import { render, staticRenderFns } from "./SelettoreRicerca.vue?vue&type=template&id=6c9d0195"
import script from "./SelettoreRicerca.vue?vue&type=script&lang=js"
export * from "./SelettoreRicerca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports